import React from 'react';

import config from "../config/config";

import AccountNavigation from './account-navigation';
import LogoutButton from '../components/logout-button';
import IFrame from '../components/iframe';

const iframeURL = `${config.DOMAIN_NAME}/${config.CLIENT_NAME}/website/secure/RedeemGift.aspx?resize=true`;

const RedeemGift = () => {

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__reset-password'>
                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'>Redeem a gift voucher</h1>
                    <div className='customer-details-form'>
                        <IFrame url={iframeURL} id="SpektrixAccountIFrame" title="Redeem a gift voucher" hasLoader="true" />
                    </div>
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />
                </div>
            </div>
        </>
    );
};

export default RedeemGift;
